import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { withStyles } from "@mui/styles";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
  FormControl,
  Snackbar,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import DebouncedTextField from "common/components/DebouncedTextField";
import Panel from "common/components/Panel";
import Resource from "common/components/Resource";
import Pagination from "common/components/Pagination";
import client from "common/admin/client";

class ListBuildings extends React.Component {
  state = {
    search: "",
    snackbar: "",
    communities: [],
  };

  handleSearchChange = (value) => this.setState({ search: value });

  async componentDidMount() {
    try {
      const communities = await client.get("communities", {
        query: { pagination: false },
      });
      this.setState({ communities });
    } catch (e) {
      this.setState({
        snackbar: "Something went wrong, please try reloading.",
      });
    }
  }

  getCommunity = (id) => {
    const community = this.state.communities.find(
      (community) => community.id === id,
    );
    return community ? community.name : id;
  };

  render() {
    const { classes, match, history } = this.props;
    const { search } = this.state;
    const queryParams = {};
    if (search) {
      queryParams.name_like = search;
    }

    return (
      <Panel title="View Buildings">
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={!!this.state.snackbar}
          autoHideDuration={4000}
          onClose={this.handleSnackbarClose}
          message={<span>{this.state.snackbar}</span>}
        />
        <Grid container direction="column" spacing={2}>
          <Grid size={{ xs: 4 }}>
            <FormControl className={classes.search}>
              <DebouncedTextField
                id="search"
                label="Search by name"
                onChange={this.handleSearchChange}
                delay={500}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Resource
          name="buildings"
          queryParams={queryParams}
          render={(buildings, { removeOne, prevPage, nextPage, page }) => (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell numeric>ID</TableCell>
                  <TableCell>Building Name</TableCell>
                  <TableCell>Neighborhood</TableCell>
                  <TableCell>City</TableCell>
                  <TableCell>Last Updated</TableCell>
                  <TableCell>Delete</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {buildings.length ? (
                  buildings.map((building) => (
                    <TableRow hover key={building.id}>
                      <TableCell numeric>{building.id}</TableCell>
                      <TableCell
                        className={classes.clickable}
                        onClick={() =>
                          history.push(`${match.url}/${building.id}`)
                        }
                      >
                        {building.name}
                      </TableCell>
                      <TableCell>
                        {this.getCommunity(building.community_id)}
                      </TableCell>
                      <TableCell>{building.city}</TableCell>
                      <TableCell>
                        {moment(building.updated_at).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell>
                        <IconButton>
                          <DeleteIcon onClick={() => removeOne(building.id)} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>No additional data found.</TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={6} className={classes.pagination}>
                    <Pagination
                      page={page}
                      nextPage={nextPage}
                      prevPage={prevPage}
                      items={buildings}
                    />
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          )}
        />
      </Panel>
    );
  }
}

const styles = (theme) => ({
  clickable: {
    cursor: "pointer",
    color: theme.palette.primary.light,
    fontWeight: "bold",
  },
  table: {
    minWidth: 700,
  },
  pagination: {
    textAlign: "right",
  },
  search: {
    paddingTop: theme.spacing(1),
  },
});

ListBuildings.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListBuildings);
